@if (cut && user && {site: currentSite$ | async, batch: currentBatch$ | async}; as items) {
  <div class="container">
    <!------- Header ------->
    <div class="header"
      [ngClass]="(isExpanded$ | async) ? 'header-expanded' : 'header-collapsed'">
      <div class="header-left">
        <div class="info">
          <div class="title">{{cut.name}}</div>
          <div class="sub-title">{{cut.center | wgs84}}</div>
        </div>
      </div>
      <div class="header-actions">
        @if (!(isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'expand' | transloco}}"
            (click)="onClickExpand()">expand_content
          </button>
        }
        @if ((isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'collapse' | transloco}}"
            (click)="onClickCollapse()">collapse_content
          </button>
        }
        <button mat-icon-button
          matTooltip="{{'close' | transloco}}"
          (click)="onClickClose()">close
        </button>
      </div>
    </div>
    <!------- Content ------->
    <div class="content"
      [ngClass]="(isExpanded$ | async) ? 'content-expanded' : 'content-collapsed'">
      <div class="main"
        [ngClass]="(isExpanded$ | async) ? 'main-expanded' : 'main-collapsed'">
<!--        @if (cut.profileDeviation) {-->
<!--          <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">-->
<!--            <div class="section-title">{{'similarity' | transloco | uppercase}} :</div>-->
<!--            <div class="indicators">{{cut.profileDeviation | similarity | number:'1.0-0'}} %</div>-->
<!--          </div>-->
<!--        }-->
        @if (graph.hasChart) {
          <div class="graph-controls">
            <div class="datasets-selector-row-direction"
              [ngClass]="(isExpanded$ | async) ? 'datasets-selector-row-direction-expanded' : 'datasets-selector-row-direction-collapsed'">
              @for (dataset of graph.datasets; track dataset; let i = $index) {
                @if (i <= 1 || dataset.label == formatDate(items?.batch?.dateAcquired)) {
                  <div
                    class="dataset-row"
                    (click)="toggleDataset(i)">
                    @if (dataset.hidden) {
                      <div
                      style="background-color: transparent!important; border: 2px solid {{dataset.backgroundColor}}; width: 12px; height: 12px; border-radius: 12px;"></div>
                    }
                    @if (!dataset.hidden) {
                      <div
                      style="background-color: {{dataset.backgroundColor}}; border: 2px solid {{dataset.backgroundColor}}; width: 12px; height: 12px; border-radius: 12px;"></div>
                    }
                    <div class="dataset-row-label">{{dataset.label}}</div>
                  </div>
                }
              }
            </div>
            @if ((isExpanded$ | async)) {
              <div class="graph-actions">
                @if (!(cut.slope?.length) && user.name == cut.author) {
                  <div>
                    <button mat-button
                      color="primary"
                      [ngClass]="{'hide': !graph.canStartDrawingSlope}"
                      (click)="graph.startDrawingSlope()">
                      {{'add_slope' | transloco}}
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        }
        <cut-chart #graph
          class="chart"
          [canEditSlope]="(isExpanded$ | async) ?? false"
          [enableZoom]="(isExpanded$ | async) ?? false"
          [ngClass]="(isExpanded$ | async) ? 'chart-expanded' : 'chart-collapsed'"
          (slopeDragging)="onSlopeDragging($event)"
          (slopeHasChanged)="onSlopeHasChanged($event)">
        </cut-chart>
        @if (slope.length && (isExpanded$ | async)) {
          <div class="slope-infos">
            @if (horizontalDistance) {
              <div>
                <div class="section-title">{{'horizontal_distance_from_slope' | transloco | uppercase}} :</div>
                <div class="indicators">{{ horizontalDistance.toFixed(2) }} m</div>
              </div>
            }
            @if (verticalDistance) {
              <div>
                <div class="section-title">{{'vertical_distance_from_slope' | transloco | uppercase}} :</div>
                <div class="indicators">{{ verticalDistance.toFixed(2) }} m</div>
              </div>
            }
            @if (angle) {
              <div>
                <div class="section-title">{{'slope_angle' | transloco | uppercase}} :</div>
                <div class="indicators">{{ angle.toFixed(2) }}°</div>
              </div>
            }
            @if ((cut.slope?.length) && user.name == cut.author) {
              <button mat-button
                color="warn"
                (click)="onClickDeleteSlope(cut)">
                {{'delete_slope' | transloco}}
              </button>
            }
          </div>
        }
        <!------- Actions ------->
        <div class="actions">
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              matTooltip="{{'move_the_camera_on_the_cut' | transloco}}"
              class="material-symbols-outlined"
              (click)="onClickFlyTo(cut)">my_location
            </button>
          }
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              [matTooltip]="(cut.show ? 'hide_overlay' : 'show_overlay') | transloco"
              [disabled]="!(displayCuts$ | async)"
              (click)="onClickToggleShow(cut)">
              <mat-icon>
                {{ cut.show ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          }
          @if (user.name == cut.author) {
            <button
              mat-icon-button
              matTooltip="{{'rename' | transloco}}"
              (click)="onClickRename(cut)"><mat-icon>edit</mat-icon></button>
            }
            @if (!cut.isShared && user.name == cut.author) {
              <button
                mat-icon-button
                matTooltip="{{'share' | transloco}}"
                (click)="onClickToggleShare(cut)">
                <mat-icon>share</mat-icon>
              </button>
            }
            @if (cut.isShared && user.name == cut.author) {
              <button
                mat-icon-button
                matTooltip="{{'share_off' | transloco}}"
                (click)="onClickToggleShare(cut)">
                <mat-icon>share_off</mat-icon>
              </button>
            }
            <button mat-icon-button
              matTooltip="{{'download' | transloco}}"
              [matMenuTriggerFor]="menu">download
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="onClickExportGraph(cut)">{{'export_graph' | transloco}}</button>
              <button mat-menu-item
              (click)="onClickGenerateDXF(cut)">{{'export_dxf' | transloco}}</button>
            </mat-menu>
            <span class="spacer"></span>
            @if (user.name == cut.author) {
              <button
                style="color: var(--warn-color)"
                mat-icon-button
                matTooltip="{{'delete' | transloco}}"
                (click)="onClickDelete(cut)">delete
              </button>
            }
          </div>
        </div>
        <div class="side"
          [ngClass]="(isExpanded$ | async) ? 'side-expanded' : 'side-collapsed'">
          <!------- Author ------->
          <!--      <div *ngIf="user.name != cut.author" class="author">{{'created_by_f' | transloco }} {{cut.author}}</div>-->
          <!------- History ------->
          <cut-history-channel class="history" [itemId]="cut.id"></cut-history-channel>
        </div>
      </div>
    </div>
  }
